export default __webpack_public_path__ + "static/media/Parallax-HUD-Targeting (Reticle).c4873519.jpg";